import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';
import { RenovationColorList } from '@/views/components/styleConfig';

@Component({
  components: {},
  mixins: [style],
})
export default class Site extends Vue {
  @Prop({ default: () => {} })
    value: NewDisplayShopInfo;

  @Prop({ default: 1 })
    themeCode: number;

  @Prop()
    fromPage: number;

  get getTheme() {
    return RenovationColorList[this.themeCode];
  }

  render(h) {
    return (
      <div class="site">
        {this?.value?.desc?.siteInfo ? <img src={`${this?.value?.desc?.siteInfo?.siteLogo}?imageView2/1/w/150/h/150`} alt="" class="logo" /> : ''}
        <div class="cont">
          <p class="title" style={{ color: this.getTheme[2] === '#000' ? '#fff' : '#000' }}>
            店铺名称
          </p>
          {this.fromPage === 1 && (
            <p class="address" style={{ color: this.getTheme[2] === '#000' ? '#fff' : '#a8a8a8' }}>
              店铺地址店铺地址店铺地址
            </p>
          )}
        </div>
        <i class="phone iconfont icondianhua" />
      </div>
    );
  }
}
